import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const CustomPagination = ({ currentPage = 1,
                              totalRows = 0,
                              perPage = 10,
                              setCurrentPage,
                              setPerPage }) => {
    const totalPages = Math.ceil(totalRows / perPage);

    return (
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-4 bg-white rounded-md p-4 drop-shadow-[0_0px_20px_rgba(203,229,255,0.3)]">
            {/* Rows per page selector */}
            <div className="flex items-center gap-2 text-sm">
                <span className="text-gray-700 font-medium">Rows per page:</span>
                <select
                    value={perPage}
                    onChange={(e) => {
                        setPerPage(Number(e.target.value));
                        setCurrentPage(1); // Reset to page 1 when rows per page change
                    }}
                    className="px-3 py-1.5 border-2 border-gray-300 rounded-md focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary"
                >
                    <option value={5}>5</option>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                </select>
            </div>

            {/* Page info and navigation */}
            <div className="flex items-center gap-3">
                {/* Page info */}
                <span className="text-sm text-gray-700 font-medium">
                    Page {currentPage} of {totalPages === 0 ? "1" : `${totalPages}`}
                </span>

                {/* Navigation buttons */}
                <div className="flex gap-2">
                    <button
                        className={`px-3 py-1.5 rounded-md flex items-center gap-1 text-sm font-medium transition-colors duration-200 ${
                            currentPage === 1
                                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                : 'bg-primary text-white hover:bg-teal-700'
                        }`}
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                        disabled={currentPage === 1}
                    >
                        <FaChevronLeft className="text-xs" />
                        <span className="hidden sm:inline">Previous</span>
                    </button>
                    <button
                        className={`px-3 py-1.5 rounded-md flex items-center gap-1 text-sm font-medium transition-colors duration-200 ${
                            currentPage === totalPages || totalPages === 0
                                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'
                                : 'bg-primary text-white hover:bg-teal-700'
                        }`}
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                        disabled={currentPage === totalPages || totalPages === 0}
                    >
                        <span className="hidden sm:inline">Next</span>
                        <FaChevronRight className="text-xs" />
                    </button>
                </div>
            </div>

            {/* Total rows info */}
            <div className="text-sm text-gray-600">
                Total: <span className="font-semibold text-primary">{totalRows}</span> {totalRows === 1 ? 'record' : 'records'}
            </div>
        </div>
    );
};

export default CustomPagination;
